var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { className } from '@empori/util';
import * as React from 'react';
import { InitialUrlQueries, UpdateUrlQueries } from '../urlParams';
function FaIcon(props) {
    var faClass = props.clsName;
    if (props.clsAltName) {
        faClass += " ".concat(props.clsAltName);
    }
    if (props.spin) {
        faClass += ' fa-spin';
    }
    faClass += ' empori-icon';
    return React.createElement("i", { className: faClass, style: {}, title: props.title });
}
function OneProductItem(props) {
    var container = React.useRef(null);
    var _a = React.useState(null), parentRect = _a[0], setParentRect = _a[1];
    var staticMargin = props.staticMargin;
    var _b = React.useState(staticMargin), marginBottom = _b[0], setMarginBottom = _b[1];
    React.useEffect(function () {
        if (container.current) {
            setParentRect(container.current.getBoundingClientRect());
        }
        var onScroll = function () {
            if (container.current) {
                setParentRect(container.current.getBoundingClientRect());
            }
        };
        window.addEventListener('scroll', onScroll);
    }, [container]);
    var handleItemToggle = function (event) {
        if (!(props.childProductItems.length > 0)) {
            return;
        }
        props.updateUrl({ itemId: props.contentId });
        if (container.current) {
            setParentRect(container.current.getBoundingClientRect());
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { onClick: handleItemToggle, ref: container, className: className('basic-grid grid-item', {
                // eslint-disable-next-line camelcase
                grid_item_hover: (props.childProductItems && props.childProductItems.length > 0) ||
                    (props.btnUrl.name != null &&
                        props.btnUrl.name !== '' &&
                        props.btnUrl.name !== undefined),
                viewing: props.childProductItems &&
                    props.childProductItems.length > 0 &&
                    props.itemToggled,
                blocked: props.itemBlocked,
                // eslint-disable-next-line camelcase
                large_box: props.itemCount <= 2
            }, props.invertedCss), style: {
                marginBottom: marginBottom,
                flex: props.itemCount >= 4
                    ? "0 0 calc(100% / ".concat(props.itemCount, " - 10px)")
                    : "1 0 calc(100% / ".concat(props.itemCount, " - ").concat(props.elementSpace, ")"),
                paddingBottom: props.btnUrl.name ||
                    (props.childProductItems && props.childProductItems.length > 0)
                    ? 32
                    : 0
            } },
            React.createElement("div", { className: className('basic-grid-info element-flex') },
                props.imageUrl && (React.createElement("div", { className: 'element-flex justify-content-center icon-image' },
                    React.createElement("img", { className: 'icon-size-image', height: props.itemCount <= 2 ? 120 : 70, src: "".concat(props.imageUrl), loading: 'lazy', alt: props.titleText }))),
                React.createElement("h3", null, props.titleText),
                React.createElement("div", { className: 'empori-news-preamble grid-description-text', dangerouslySetInnerHTML: { __html: props.descriptionText } }),
                props.childProductItems && props.childProductItems.length > 0 && (React.createElement("div", { className: 'link-expand' }, props.itemToggled ? (React.createElement("div", { className: 'empori-button text-like', key: 'open' },
                    React.createElement("i", { className: 'fa-regular fa-times fa-2x' }))) : (React.createElement("div", { className: 'empori-button text-like', key: 'closed' },
                    React.createElement("i", { className: 'fa-regular fa-angle-down fa-2x' })))))),
            props.childProductItems && props.childProductItems.length === 0 && (React.createElement("div", { className: className('link', {
                    // eslint-disable-next-line camelcase
                    large_box_link: props.itemCount <= 2
                }), style: {
                    bottom: props.btnUrl.name ? 32 : 10
                } },
                React.createElement("a", { href: "".concat(props.btnUrl.url), className: 'empori-button text-like', title: props.btnUrl.name + ' - ' + props.titleText },
                    props.btnUrl.name,
                    ' ',
                    props.btnUrl.name &&
                        (props.urlIcon && props.urlIcon.startsWith('/media') ? (React.createElement("img", { src: props.urlIcon, alt: 'icon', height: '16', className: 'icon-picker-image', loading: 'lazy' })) : (React.createElement(FaIcon, { clsName: props.urlIcon }))))))),
        props.itemToggled &&
            parentRect &&
            props.childProductItems &&
            props.childProductItems.length > 0 && (React.createElement(ChildProductItems, __assign({}, props, { parentRect: parentRect, setParentMargin: setMarginBottom, closeItem: handleItemToggle })))));
}
export function ChildProductItems(props) {
    if (!props.parentRect || !props.itemToggled) {
        return null;
    }
    var _a = React.useState(0), topPos = _a[0], setTopPos = _a[1];
    var staticTopLoss = 20;
    var container = React.useRef(null);
    var isCardShow = function (item) {
        if (item.imageUrl || item.titleText || item.descriptionText) {
            return true;
        }
        else if (window.innerWidth > 540) {
            return true;
        }
        else {
            return false;
        }
    };
    React.useEffect(function () {
        setTopPos(props.scrollY +
            props.parentRect.height +
            props.parentRect.top -
            staticTopLoss);
    }, []);
    React.useLayoutEffect(function () {
        if (container.current) {
            props.setParentMargin(container.current.clientHeight);
        }
        return function () {
            setTopPos(0);
            props.setParentMargin(staticTopLoss);
        };
    }, [container]);
    return (React.createElement("div", { ref: container, className: 'grid-expanded-wrapper', style: { top: topPos, left: 0 } },
        React.createElement("div", { className: 'container' },
            React.createElement("div", { className: 'grid-expanded-content basic-grid-content element-flex information-grid expanded' }, props.childProductItems.map(function (item, index) {
                return isCardShow(item) && (React.createElement("div", { key: "".concat(item.contentId, "-").concat(index++), className: className('basic-grid grid-item', {
                        // eslint-disable-next-line camelcase
                        grid_item_hover: (props.childProductItems &&
                            props.childProductItems.length > 0) ||
                            (props.btnUrl.name != null &&
                                props.btnUrl.name !== '' &&
                                props.btnUrl.name !== undefined),
                        // eslint-disable-next-line camelcase
                        large_box: props.itemCount <= 2
                    }, props.invertedCss), style: {
                        flex: props.itemCount >= 4
                            ? "0 0 calc(100% / ".concat(props.itemCount, " - 10px)")
                            : "1 0 calc(100% / ".concat(props.itemCount, " - ").concat(props.elementSpace, ")"),
                        paddingBottom: item.btnUrl.name ||
                            (props.childProductItems &&
                                props.childProductItems.length > 0)
                            ? 32
                            : 0
                    } },
                    React.createElement("div", { className: className('basic-grid-info element-flex') },
                        item.imageUrl && (React.createElement("div", { className: 'element-flex justify-content-center icon-image' },
                            React.createElement("img", { className: 'icon-size-image', width: 300, height: props.itemCount <= 2 ? 120 : 70, src: "".concat(item.imageUrl), loading: 'lazy', alt: item.titleText }))),
                        React.createElement("h3", null, item.titleText),
                        React.createElement("div", { className: 'empori-news-preamble grid-description-text', dangerouslySetInnerHTML: { __html: item.descriptionText } }),
                        props.itemCount >= 4 && (React.createElement("a", { href: "".concat(item.btnUrl.url), className: 'empori-button text-like btn-expanded' },
                            item.btnUrl.name,
                            ' ',
                            item.btnUrl.name &&
                                (props.urlIcon &&
                                    props.urlIcon.startsWith('/media') ? (React.createElement("img", { src: props.urlIcon, alt: 'icon', height: '16', className: 'icon-picker-image', loading: 'lazy' })) : (React.createElement(FaIcon, { clsName: props.urlIcon })))))),
                    props.itemCount < 4 && (React.createElement("div", { className: className('link', {
                            // eslint-disable-next-line camelcase
                            large_box_link: props.itemCount <= 2
                        }), style: {
                            bottom: item.btnUrl.name ? 32 : 10
                        } },
                        React.createElement("a", { href: "".concat(item.btnUrl.url), className: 'empori-button text-like' },
                            item.btnUrl.name,
                            ' ',
                            item.btnUrl.name &&
                                (props.urlIcon &&
                                    props.urlIcon.startsWith('/media') ? (React.createElement("img", { src: props.urlIcon, alt: 'icon', height: '16', className: 'icon-picker-image', loading: 'lazy' })) : (React.createElement(FaIcon, { clsName: props.urlIcon }))))))));
            })))));
}
export default function ProductItem(props) {
    var _a = React.useState(InitialUrlQueries()), viewingParams = _a[0], setViewingParams = _a[1];
    var _b = React.useState(0), scrollY = _b[0], setScrollY = _b[1];
    var reset = function () {
        setViewingParams({ itemId: 0 });
    };
    var handleUrl = function (query) {
        setScrollY(window.scrollY);
        if (query.itemId === viewingParams.itemId) {
            reset();
            return;
        }
        UpdateUrlQueries(query);
        setViewingParams(query);
    };
    var isSmallScreen = window.innerWidth <= 540;
    React.useLayoutEffect(function () {
        setScrollY(window.scrollY);
    }, []);
    var isCardShow = function (item) {
        if (item.imageUrl || item.titleText || item.descriptionText) {
            return true;
        }
        else if (window.innerWidth > 540) {
            return true;
        }
        else {
            return false;
        }
    };
    return (React.createElement("div", { className: 'basic-grid-content information-grid element-flex' },
        props.products.productItems.map(function (item, index) {
            return isCardShow(item) && (React.createElement(OneProductItem, { key: "".concat(item.titleText, "-").concat(index++), itemCount: props.products.itemCount, elementSpace: props.products.elementSpace, invertedCss: props.products.invertedCss, urlIcon: props.products.urlIcon, scrollY: scrollY, contentId: item.contentId, imageUrl: item.imageUrl, titleText: item.titleText, descriptionText: item.descriptionText, btnUrl: item.btnUrl, childProductItems: item.childProductItems, itemToggled: viewingParams.itemId === item.contentId, itemBlocked: viewingParams.itemId > 0 &&
                    viewingParams.itemId !== item.contentId &&
                    props.products.productItems.filter(function (x) { return x.childProductItems.length > 0; }).length > 0, updateUrl: handleUrl, staticMargin: props.products.productItems.filter(function (x) { return x.childProductItems.length > 0; }).length > 0
                    ? 20
                    : 5 }));
        }),
        props.products &&
            props.products.productItems &&
            props.products.productItems.length === 0 && (React.createElement("div", null, "No Items Selected"))));
}
